export const AUTH_EXPIRED_EVENT = 'module-eval:auth-expired';

export const apiFetch = async (url, options = {}, config = {}) => {
  const { authCheck = true } = config;
  const mergedOptions = {
    credentials: 'include',
    ...options,
    headers: {
      ...(options.headers || {}),
    },
  };

  const response = await fetch(url, mergedOptions);

  if (authCheck && response.status === 401 && typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
  }

  return response;
};
